<template>
    <button class="side-menu-toggler" @click.stop="toggle">
        <div class="side-menu-toggler-icon mx-auto" :class="[ hasOverlays ? 'side-menu-toggler-icon-cross' : '' ]">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
    </button>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters([
        'hasOverlays'
      ])
    },
    methods: {
      toggle () {
        this.showHeader()

        if (this.hasOverlays) {
          this.hideOverlays()
        } else {
          this.toggleSideMenu()
        }
      },
      ...mapActions([
        'hideOverlays',
        'showHeader',
        'toggleSideMenu'
      ])
    }
  }
</script>

<style lang="scss">
    @import '~@/assets/styles/app';

    .landing-header {
        .side-menu-toggler {
            height: px2rem(50px);
            transition: transform .15s ease-in-out;
            width: px2rem(50px);

            &-icon {
                height: px2rem(15px);
                position: relative;
                width: px2rem(24px);

                > span {
                    background-color: #565656;
                    display: block;
                    height: 3px;
                    left: 0;
                    opacity: 1;
                    position: absolute;
                    transform: rotate(0deg);
                    transition: .3s ease-in-out;
                    width: 100%;

                    &:nth-child(1) {
                        top: 0;
                    }
                    &:nth-child(2) {
                        top: 6px;
                    }
                    &:nth-child(3) {
                        top: 6px;
                    }
                    &:nth-child(4) {
                        top: 12px;
                    }
                }

                &-cross {
                    > span {
                        &:nth-child(1) {
                            left: 50%;
                            top: 6px;
                            width: 0%;
                        }
                        &:nth-child(2) {
                            transform: rotate(45deg);
                        }
                        &:nth-child(3) {
                            transform: rotate(-45deg);
                        }
                        &:nth-child(4) {
                            left: 50%;
                            top: 6px;
                            width: 0%;
                        }
                    }
                }
            }

            &:hover {
                transform: scale(1.15);
            }
        }
    }
</style>


// WEBPACK FOOTER //
// SideMenuToggler.vue?a6fe0844